'use client'

import React from 'react'
import { MobileAppPromotion } from './mobileAppPromotion'
import { useLocale, useTranslations } from 'next-intl'

const MobileAppPromotionWrapper: React.FC = () => {
    const t = useTranslations('homePage.promotion')
    const tFooter = useTranslations('footer')
    const locale = useLocale()

    return (
        <MobileAppPromotion t={t} tFooter={tFooter} isRtl={locale === 'ar'} />
    )
}

export { MobileAppPromotionWrapper }
export default MobileAppPromotionWrapper
